import { render, staticRenderFns } from "./EditIDCard.vue?vue&type=template&id=d841a6b4&"
import script from "./EditIDCard.vue?vue&type=script&lang=js&"
export * from "./EditIDCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports